export const USER_GROUP_DRAG_TYPE = 'application/x-user-group-users';
